import { useSyncExternalStore } from 'react';

const query = '(max-width: 1199px)';
const subscribe = callback => {
  const media = window.matchMedia(query);
  media.addEventListener('change', callback);
  return () => media.removeEventListener('change', callback);
};
export const useCompactLayout = () => useSyncExternalStore(subscribe, () => window.matchMedia(query).matches, () => false);